import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSchemaViewerBoolDiscrete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={17}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      style={{
        fill: "#367e9c",
      }}
      d="M18 6V5h-4v7h1V9h2V8h-2V6zM11 3h1v11h-1zM10 5H5v1h2v6h1V6h2z"
    />
  </svg>
);
const Memo = memo(SvgSchemaViewerBoolDiscrete);
export default Memo;
